import {Fragment, useState} from "react";
import {Button, Col, Container, Modal, Row} from "react-bootstrap";
import {useSelector} from "react-redux";
import cogoToast from "cogo-toast";
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import BootstrapTable from "react-bootstrap-table-next";
export default function NewUser(){

    const  PlaySms= ()=>{let smsSound=new Audio("/sms.mp3"); smsSound.play()}
    let state=useSelector((state)=> state);

    const [ColumnCoEfficient, setColumnCoEfficient]=useState([{}]);
    const [DataCoEffeciant, setDataCoEffeciant]=useState([]);
    const[Sex, setSex]=useState("Male");
    const[Data, setData]=useState([]);
    const[ID, setID]=useState();
    const[Name, setName]=useState();
    const[Designation, setDesignation]=useState();
    const [Division, setDivision]=useState([]);
    const [Circle, setCircle]=useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const selectRow={
        mode:'radio',
        onSelect:(row,isSelect,rowIndex)=>{
            setName(row["Name"]);
            setID(row["ID"]);
            setDesignation(row["Access"]);
            handleShow()
        }
    }

    const getUser=()=>{

       let jsonObject={"sql":"Select ID,Name,User_Name,Designation,Access,Posting,Commissionerate,Division,Circle,Mobile From Account"};
        setColumnCoEfficient([{}]);setDataCoEffeciant([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnCoEfficient(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataCoEffeciant(result);

            }
        }).catch(error=>{ });
    }
    const resetPassword=()=>{

        let ResetID=document.getElementById("deletId").value;


        let jsonObject={"sql":"UPDATE `Account` SET `password`='123456789' WHERE id='"+ResetID+"' "};

        if(ResetID==""){cogoToast.error("Please select User ID")}else{
            RestClient.PostRequest(AppUrl.updateData,jsonObject).then(result=>{
                cogoToast.success("Password reset")
                PlaySms();
                }).catch(error=>{cogoToast.error(error);});

        }

    }

    const deleteUser=()=>{

        let jsonObject={"sql":"DELETE FROM `Account` WHERE id='"+ID+"' "};




        RestClient.PostRequest(AppUrl.deleteData,jsonObject).then(result=>{
               if(result==1){cogoToast.success("Data deleted successfully")
                   RestClient.PostRequest(AppUrl.getData,{"sql":"Select * From Account"}).then(result=>{setData(result)}).catch(error=>{cogoToast.error(error);});
                    handleClose();
                   PlaySms();

               }else{
                   cogoToast.error("Data not delete")
               }
        }).catch(error=>{
            cogoToast.error(error);

        });






    }
    const saveUser=()=>{

        const Commi = document.getElementById("cmbBinCommi");
        const CommiValue = Commi.options[Commi.selectedIndex].text;

        const Division = document.getElementById("cmbBinDivision");
        const DivisionValue = Division.options[Division.selectedIndex].text;

        const Circle = document.getElementById("cmbBinCircle");
        const CircleValue = Circle.options[Circle.selectedIndex].text;

        const AccessType = document.getElementById("cmbAccessType");
        const AccessTypeValue = AccessType.options[AccessType.selectedIndex].text;

        const Designation = document.getElementById("cmbDesignation");
        const DesignationValue = Designation.options[Designation.selectedIndex].text;

        const Posting = document.getElementById("cmbPosting");
        const PostingValue = Posting.options[Posting.selectedIndex].text;

        const ClientName=document.getElementById("txtClientId").value;
        const ClientMobile=document.getElementById("txtClientMobile").value;
        const UserName=document.getElementById("txtUserName").value;
        const Password=document.getElementById("txtPassword").value;




        let jsonObject={"sql":"INSERT INTO `Account` (`id`, `name`, `user_name`, `password`, `access`, `designation`,`posting`, `Commissionerate`, `Division`,`Circle`,`Mobile`)" +
                " VALUES (NULL, '"+ClientName+"', '"+UserName+"', '"+Password+"', '"+AccessTypeValue+"','"+DesignationValue+"','"+PostingValue+"', '"+CommiValue+"','"+DivisionValue+"','"+CircleValue+"','"+ClientMobile+"')"};



        if(Designation.selectedIndex==0){cogoToast.error("Please select Designation")}else{
        if(AccessType.selectedIndex==0){cogoToast.error("Please select Type")}else{
        if(Posting.selectedIndex==0){cogoToast.error("Please select Posting")}else{
            if(ClientName==""){cogoToast.error("Please Inert Name")}else{
            if(ClientMobile==""){cogoToast.error("Please Inert Mobile")}else{
                if(UserName==""){cogoToast.error("Please insert User Name")}else{
                    if(Password==""){cogoToast.error("Please Insert Password")}else{

                                        RestClient.PostRequest(AppUrl.saveData,jsonObject).then(result=>{
                                            if(result==1){PlaySms(); cogoToast.success("User Saved Saved");}else{cogoToast.warn("Data not Saved");}

                                        }).catch(error=>{
                                            cogoToast.error(error);

                                        });

                                    }}}}}}}




    }

    return(
        <Fragment>
               <Container>
                <Row>
                    <Col lg={3} sm={12}>

                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Designation</label></Col>
                            <Col lg={7}>
                                <select className=" w-100 float-right" id="cmbDesignation"  >
                                <option >-Select Type-</option>
                                <option >Member</option>
                                <option >Commissioner</option>
                                <option >ADC</option>
                                <option >JC</option>
                                <option >DC</option>
                                <option >AC</option>
                                <option >AP</option>
                                <option >RO</option>
                                <option >ARO</option>
                                <option >UD</option>

                            </select>
                            </Col>

                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">NBR</label></Col>
                            <Col lg={7}>
                                <select className="float-start w-100 customfontsize" id="cmbBinCommi"
                                        onChange={()=>{
                                            setDivision([]);
                                            setCircle([]);
                                            const e = document.getElementById("cmbBinCommi");
                                            const value = e.options[e.selectedIndex].value;
                                            const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                            setDivision(dt)


                                        }}
                                >
                                    <option >NBR</option>

                                    {
                                        state.commi.map((ctr,index)=>{
                                            return (
                                                <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                            )
                                        })

                                    }
                                </select>
                            </Col>
                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Division</label></Col>
                            <Col lg={7}>
                                <select className="float-start w-100 customfontsize" id="cmbBinDivision"
                                        onChange={()=>{
                                            setCircle([])
                                            const e = document.getElementById("cmbBinDivision");
                                            const value = e.options[e.selectedIndex].value;
                                            const dt=state.circle.filter(x => x.Division_Id==value);
                                            setCircle(dt)


                                        }}
                                >
                                    <option >All Division</option>

                                    {
                                        Division.map((ctr,index)=>{
                                            return (
                                                <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                            )
                                        })

                                    }
                                </select>
                            </Col>
                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Circle</label></Col>
                            <Col lg={7}>
                                <select className="float-start w-100 customfontsize" id="cmbBinCircle" >
                                    <option >All Circle</option>

                                    {
                                        Circle.map((ctr,index)=>{
                                            return (
                                                <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                            )
                                        })

                                    }


                                </select>
                            </Col>
                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Posting</label></Col>
                            <Col lg={7}>
                                <select className=" w-100 float-right" id="cmbPosting"  >
                                    <option >-Select Type-</option>
                                    <option >All</option>
                                    <option >GL</option>
                                    <option >ET</option>
                                    <option >Law</option>
                                    <option >Statistics  </option>
                                    <option >AP  </option>


                                </select>
                            </Col>

                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Access Type</label></Col>
                            <Col lg={7}>
                                <select className=" w-100 float-right" id="cmbAccessType"  >
                                    <option >-Select Type-</option>
                                    <option >admin</option>
                                    <option >ADC</option>
                                    <option >Division</option>
                                    <option >Circle</option>
                                    <option >Section</option>
                                    <option >AP</option>
                                    <option >GL</option>
                                    <option >ET</option>
                                    <option >Law</option>
                                    <option >EFD</option>
                                    <option >Other</option>


                                </select>
                            </Col>

                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Name</label></Col>
                            <Col lg={7}> <input id="txtClientId"/></Col>

                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Mobile</label></Col>
                            <Col lg={7}> <input id="txtClientMobile"/></Col>

                        </Row>
                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">User Name</label></Col>
                            <Col lg={7}> <input id="txtUserName" type="text" /></Col>

                        </Row>

                        <Row className="mt-2 text-justify">
                            <Col lg={5}><label className="customfontsize">Password</label></Col>
                            <Col lg={7}> <input id="txtPassword" type="text" /></Col>

                        </Row>

                        <Row className="mt-2 text-justify">
                            <Col lg={5}> </Col>
                            <Col lg={7}><Button onClick={saveUser} className="w-100">Save</Button></Col>
                        </Row>
                    </Col>
                    <Col lg={9} sm={12}>
                        <div className="purchaseDiv text-center">

                            <Row >

                                <Col lg={6} md={6} sm={6}><Button onClick={getUser}  className="w-50 m-4"  >Search User</Button></Col>
                                <Col lg={6} md={6} sm={6}>
                                    <Row className="m-4">
                                        <Col lg={2}>ID</Col>
                                        <Col lg={3} sm={6}><input id="deletId"   className="mt-1 w-50"/></Col>
                                        <Col lg={7} sm={6}><Button className="mt-1" onClick={resetPassword}>Reset Password</Button></Col>
                                    </Row>


                                </Col>
                            </Row>

                            <div className="tableDiv overflow-scroll">
                                <BootstrapTable  keyField='ID' data={DataCoEffeciant} columns={ColumnCoEfficient} selectRow={selectRow} > </BootstrapTable>
                            </div>





                        </div>
                    </Col>
                </Row>

               </Container>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Do you want to delete?</Modal.Title>


                </Modal.Header>
                <Modal.Body>

                    <label className="w-25">ID:</label><input value={ID} disabled={true} className="w-25"/><br/>
                    <label className="w-25 mt-2">Name:</label><input value={Name} disabled={true} className="w-25"/><br/>
                    <label className="w-25 mt-2">Access:</label><input value={Designation} disabled={true} className="w-25"/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="success" onClick={deleteUser} >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}
